import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'pciRelatorio'

const GetAll = (empresaID, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${empresaID}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Delete = (id = '', config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, config)

const PCIReportRepository = {
  GetAll,
  Create,
  Update,
  Delete
}

export default PCIReportRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pcireport.js